module.exports = __webpack_public_path__ + "static/media/logo_kpay.cf6b5ccb.svg";